export const useBatch = () => {
  const { $t } = useNuxtApp()
  const state = reactive<{
    batchVisible: boolean
    checkList: any[]
  }>({
    batchVisible: false,
    checkList: [],
  })

  const exitBatch = () => {
    state.checkList = []
    state.batchVisible = false
  }

  const Bulk = {
    text: $t('pi-liang-cao-zuo'),
    props: { disabled: ({ list }: any) => list.length === 0 },
    onClick: () => (state.batchVisible = true),
  }

  const Exit = {
    text: $t('tui-chu-cao-zuo'),
    props: { disabled: false },
    onClick: exitBatch,
  }

  return { state, exitBatch, Bulk, Exit }
}
